import { DefaultButton, FontIcon, mergeStyles, MessageBar, MessageBarType, Panel, PanelType, Pivot, PivotItem, PrimaryButton, ProgressIndicator, Stack, Text, useTheme } from '@fluentui/react';
import * as React from 'react';
import { IAttendeeRegistrationListItem, IAttendeeRegistrationListItemSelected } from '../../../../../Models/Event/IAttendeeRegistrationListItem';
import { IStatusMessage } from '../../../../../Models/IStatusMessage';
import { AttendeeRegistrationDetailView } from './AttendeeRegistrationDetailView';
import { CreateInvoiceFromRegistration } from "../../../Invoices/CreateInvoiceFromRegistration/CreateInvoiceFromRegistration"
import { useBoolean } from '@fluentui/react-hooks';
import * as Services from '../../../../../Services/Services';
import { IEventApi } from '../../../../../Services/API/Event/IEventApi';
import { IUpdateEventRegistration } from '../../../../../Models/Registration/IUpdateEventRegistration';
import { IUserProfile } from '../../../../../Models/Profile/IUserProfile';
import { IAdminApi } from '../../../../../Services/API/Admin/IAdminApi';
import { IUserInvoiceInfo } from '../../../../../Models/Admin/IUserInvoiceInfo';
import { ProfileApi } from '../../../../../Services/API/Profile/ProfileApi';
import { RegistrationDetail } from '../../../../Registration/RegistrationDetail/RegistrationDetail';
import { AttendeeRegistrationContacts } from './AttendeeRegistrationContacts';

interface IAttendeeRegistrationDetailProps {
    item?: IAttendeeRegistrationListItemSelected;
    eventName: string;
    isOpen: boolean;
    close: () => void;
    refresh?: () => void;
    profile: IUserProfile;
}


export const AttendeeRegistrationDetail: React.FunctionComponent<IAttendeeRegistrationDetailProps> = (props) => {

    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [itemEdit, setItemEdit] = React.useState<IAttendeeRegistrationListItemSelected>();
    const [createInvoiceModal, setCreateInvoiceModal] = useBoolean(false);
    const [createInvoiceSemester, setCreateInvoiceSemester] = React.useState(0);
    const [userInvoiceInfo, setUserInvoiceInfo] = React.useState<IUserInvoiceInfo>();

    const theme = useTheme();
    const iconClass = mergeStyles({
        fontSize: 50,
        height: 50,
        width: 50,
        margin: '0 25px',
        color: theme.palette.themePrimary
    });

    const propertyChanged = (key: string, value: any) => {
        if (itemEdit) {
            setItemEdit({ ...itemEdit, [key]: value });
        }
    }


    const loadUserInvoiceInfo = async (userId: string) => {

        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const adminApi = Services.ServicesProvider.GetService<IAdminApi>(Services.AdminApi);
        const result = await adminApi.getUserInvoiceInfo(userId);
        if (result.isSuccess && result.data) {
            setUserInvoiceInfo(result.data);
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    React.useEffect(() => {
        if (props.item) {
            if (props.profile.isAccountant || props.profile.isAdmin) {
                loadUserInvoiceInfo(props.item.userId);
            }
            setItemEdit(props.item);
        }
    }, [props.item])

    const createInvoice = (semester: number) => {
        setCreateInvoiceSemester(semester);
        setCreateInvoiceModal.setTrue();
    }

    const updateRegistration = async (registration: IAttendeeRegistrationListItem) => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const eventApi = Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
        const data: IUpdateEventRegistration = {
            eventId: registration.eventId,
            priceType: registration.priceType,
            firstSemesterPrice: registration.firstSemesterPrice,
            secondSemesterPrice: registration.secondSemesterPrice,
            price: registration.price,
            isSubstitute: registration.isSubstitute,
            registrationId: registration.id,
            isActive: registration.isActive,
            acceptMarketing: registration.acceptMarketing,
            acceptPromotion: registration.acceptPromotion,
            doprovod: registration.doprovod,
           }
        const result = await eventApi.updateEventRegistration(data);

        if (result.isSuccess) {
            setStatusMessage({ message: result.message, type: MessageBarType.success });
            props.refresh && props.refresh();
            props.close();
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const save = () => {
        if (itemEdit) {
            updateRegistration(itemEdit);
        }
    }


    const sendRegistrationByEmail = async (registrationId: number) => {

        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const eventApi = Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
        const result = await eventApi.sendRegistrationByEmail(registrationId);
        if (result.isSuccess) {
            setStatusMessage({ message: "Email byl úspěšně odeslán", type: MessageBarType.success });                        
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }


    return (
        <>
            {props.isOpen ?
                <Panel
                    isOpen={props.isOpen}
                    onDismiss={props.close}
                    type={PanelType.medium}
                    isBlocking={false}
                    closeButtonAriaLabel="Zavřít">
                    <Stack>
                        <Stack horizontal>
                            <Stack horizontalAlign='end' styles={{ root: { width: 80 } }}>
                                <FontIcon iconName="AccountManagement" className={iconClass} />
                            </Stack>

                            <Stack horizontal verticalAlign="center">
                                <Text styles={{ root: { fontWeight: 600 } }} variant="xLarge">
                                    {"Registrace: " + props.item?.firstName + " " + props.item?.lastName}
                                </Text>
                            </Stack>
                        </Stack>
                        <Pivot>
                            <PivotItem headerText="Registrace">
                        <AttendeeRegistrationDetailView
                            sendRegistrationByEmail={sendRegistrationByEmail}
                            profile={props.profile}
                            isLoading={isLoading}
                            propertyChanged={propertyChanged}
                            item={itemEdit}
                            createInvoice={createInvoice} />
                        <Stack styles={{ root: { height: 10 } }}>
                            {isLoading ? <ProgressIndicator /> : null}
                        </Stack>
                        <Stack horizontal tokens={{ padding: 20, childrenGap: 15 }} horizontalAlign="center">
                            {props.profile.isAdmin?  <PrimaryButton onClick={save}>Uložit</PrimaryButton>:null }
                            <DefaultButton onClick={props.close}>Zavřít</DefaultButton>
                        </Stack>
                        {statusMessage && statusMessage.message ? <MessageBar messageBarType={statusMessage.type}>{statusMessage.message}</MessageBar> : null}
                    </PivotItem>
                    {itemEdit?.userId ?
                        <PivotItem headerText="Kontaktní informace">
                            <AttendeeRegistrationContacts userId={itemEdit?.userId} />
                        </PivotItem> : null}
                </Pivot>
                    </Stack>
                </Panel> : null
            }
            {itemEdit && userInvoiceInfo && createInvoiceModal ?
                <CreateInvoiceFromRegistration
                    userInvoiceInfo={userInvoiceInfo}
                    profile={props.profile}
                    isOpen={createInvoiceModal}
                    close={setCreateInvoiceModal.setFalse}
                    item={itemEdit}
                    eventName={props.eventName}
                    semester={createInvoiceSemester}
                    refresh={() => { props.refresh && props.refresh() }}
                /> : null}
        </>)
    
}
